import { QuesState } from 'shared/types/QuesTypes';
import {
	ADD_TRANSLATION_LANGUAGE,
	GET_GOOGLE_LANGUAGES_LIST,
	GetGoogleLanguagesListAction,
	GoogleLanguagesDataList,
	SET_GOOGLE_LANGUAGES_LIST,
	SetGoogleLanguagesListAction,
	AddTranslationLanguageAction,
	SaveTranslationLanguageAction,
	SAVE_TRANSLATION_LANGUAGE,
	DeleteTranslationLanguageAction,
	DELETE_TRANSLATION_LANGUAGE,
	GetTranslatedDataAction,
	GET_TRANSLATED_DATA,
	SetTranslatedDataAction,
	SET_TRANSLATED_DATA,
	ChangeQuestionTranslateInfo,
	CHANGE_QUESTION_TRANSLATE_INFO,
	SetTranslatedQuestionInfo,
	SET_TRANSLATED_QUESTION_INFO,
	ChangeOptionTranslateInfo,
	CHANGE_OPTION_TRANSLATE_INFO,
	ChangeSectionTranslateInfo,
	CHANGE_SECTION_TRANSLATE_INFO,
	CHANGE_QUESTION_SETTING_TRANSLATE_INFO,
	ChangeQuestionSettingTranslateInfo,
	CHANGE_MULTIPLE_OPINION_SECTION_TRANSLATE_INFO,
	ChangeMultipleOpinionSectionTranslateInfo,
	CHANGE_MULTIPLE_OPINION_STROKE_TRANSLATE_INFO,
	ChangeMultipleOpinionStrokeTranslateInfo,
	GetAllTranslatedLanguagesAction,
	GET_ALL_TRANSLATED_LANGUAGES,
	SetAllTranslatedLanguagesAction,
	SET_ALL_TRANSLATED_LANGUAGES,
	UPLOAD_MULTI_LINGUAL_CSV,
	UploadMultiLingualCsv,
	GetDefaultButtonsDataAction,
	GET_DEFAULT_BUTTONS_DATA,
	DefaultButtonsDataListType,
	SetDefaultButtonsDataAction,
	SET_DEFAULT_BUTTONS_DATA,
	GetTranslatedButtonsDataAction,
	GET_TRANSLATED_BUTTONS_DATA,
	PostTranslateButtonsData,
	POST_TRANSLATE_BUTTONS_DATA,
	SetTranslatedButtonDataAction,
	SET_TRANSLATED_BUTTON_DATA,
	ChangeButtonsTranslateInfo,
	CHANGE_BUTTONS_TRANSLATE_INFO,
	SetTranslatedButtonsInfo,
	SET_TRANSLATED_BUTTONS_INFO,
	UpdateLangugaeStatus,
	UPDATE_LANGUGAE_STATUS,
} from './types';
import { SurveySection } from 'shared/types/SurveyResponses';

export const getAllTranslatedLanguagesAction: (surveyId: string) => GetAllTranslatedLanguagesAction = (surveyId) => ({
	type: GET_ALL_TRANSLATED_LANGUAGES,
	payload: { surveyId },
});

export const getGoogleLanguagesListAction = (): GetGoogleLanguagesListAction => ({
	type: GET_GOOGLE_LANGUAGES_LIST,
	payload: undefined,
});

export const setAllTranslatedLanguagesAction: (data: GoogleLanguagesDataList[]) => SetAllTranslatedLanguagesAction = (
	data
) => ({
	type: SET_ALL_TRANSLATED_LANGUAGES,
	payload: { data },
});

export const setGoogleLanguagesListAction: (data: GoogleLanguagesDataList[]) => SetGoogleLanguagesListAction = (
	data
) => ({
	type: SET_GOOGLE_LANGUAGES_LIST,
	payload: { data },
});

export const addTranslationLanguageAction: (
	languages: GoogleLanguagesDataList[],
	surveyId: string,
	autoTranslate: boolean
) => AddTranslationLanguageAction = (languages, surveyId, autoTranslate) => ({
	type: ADD_TRANSLATION_LANGUAGE,
	payload: { languages, surveyId, autoTranslate },
});

export const saveTranslationLanguageAction: (languages: GoogleLanguagesDataList[]) => SaveTranslationLanguageAction = (
	languages
) => ({
	type: SAVE_TRANSLATION_LANGUAGE,
	payload: { languages },
});

export const deleteTranslationLanguageAction: (surveyId: string, langCode: string) => DeleteTranslationLanguageAction =
	(surveyId, langCode) => ({
		type: DELETE_TRANSLATION_LANGUAGE,
		payload: { surveyId, langCode },
	});

export const getTranslatedDataAction: (surveyId: string, langCode: string) => GetTranslatedDataAction = (
	surveyId,
	langCode
) => ({
	type: GET_TRANSLATED_DATA,
	payload: { surveyId, langCode },
});

export const setTranslatedDataAction: (data: any) => SetTranslatedDataAction = (data) => ({
	type: SET_TRANSLATED_DATA,
	payload: { data },
});

export const changeQuestionTranslateInfo: (
	questionId: string,
	languageCode: string,
	surveyId: string,
	content
) => ChangeQuestionTranslateInfo = (questionId, languageCode, surveyId, content) => ({
	type: CHANGE_QUESTION_TRANSLATE_INFO,
	payload: {
		questionId,
		languageCode,
		surveyId,
		content,
	},
});

export const changeOptionTranslateInfo: (
	questionId: string,
	languageCode: string,
	optionId: string,
	value: string
) => ChangeOptionTranslateInfo = (questionId, languageCode, optionId, value) => ({
	type: CHANGE_OPTION_TRANSLATE_INFO,
	payload: {
		questionId,
		languageCode,
		optionId,
		value,
	},
});

export const changeSectionTranslateInfo: (
	id: string,
	languageCode: string,
	surveyId: string,
	metaData
) => ChangeSectionTranslateInfo = (id, languageCode, surveyId, metaData) => ({
	type: CHANGE_SECTION_TRANSLATE_INFO,
	payload: {
		id,
		languageCode,
		surveyId,
		metaData,
	},
});

export const changeQuestionSettingTranslateInfo: (
	questionId: string,
	languageCode: string,
	surveyId: string,
	settings,
	isSection: boolean
) => ChangeQuestionSettingTranslateInfo = (questionId, languageCode, surveyId, settings, isSection) => ({
	type: CHANGE_QUESTION_SETTING_TRANSLATE_INFO,
	payload: {
		questionId,
		languageCode,
		surveyId,
		settings,
		isSection,
	},
});

export const changeMultipleOpinionSectionTranslateInfo: (
	sectionId: string,
	questionId: string,
	languageCode: string,
	content
) => ChangeMultipleOpinionSectionTranslateInfo = (sectionId, questionId, languageCode, content) => ({
	type: CHANGE_MULTIPLE_OPINION_SECTION_TRANSLATE_INFO,
	payload: {
		sectionId,
		questionId,
		languageCode,
		content,
	},
});

export const changeMultipleOpinionStrokeTranslateInfo: (
	sectionId: string,
	questionId: string,
	languageCode: string,
	strokeId: string,
	text: string,
	content
) => ChangeMultipleOpinionStrokeTranslateInfo = (sectionId, questionId, languageCode, strokeId, text, content) => ({
	type: CHANGE_MULTIPLE_OPINION_STROKE_TRANSLATE_INFO,
	payload: {
		sectionId,
		questionId,
		languageCode,
		strokeId,
		text,
		content,
	},
});

export const setTranslatedQuestionInfo: (
	questionId: string,
	state: QuesState | SurveySection
) => SetTranslatedQuestionInfo = (questionId, state) => ({
	type: SET_TRANSLATED_QUESTION_INFO,
	payload: {
		questionId,
		state,
	},
});

export const uploadMultiLingualCsv: (
	file: File,
	languageCode: string,
	questionnaireId: string
) => UploadMultiLingualCsv = (file, languageCode, questionnaireId) => ({
	type: UPLOAD_MULTI_LINGUAL_CSV,
	payload: {
		file,
		languageCode,
		questionnaireId,
	},
});

export const getDefaultButtonsDataAction = (): GetDefaultButtonsDataAction => ({
	type: GET_DEFAULT_BUTTONS_DATA,
	payload: undefined,
});

export const setDefaultButtonsDataAction: (data: DefaultButtonsDataListType[]) => SetDefaultButtonsDataAction = (
	data
) => ({
	type: SET_DEFAULT_BUTTONS_DATA,
	payload: {
		data,
	},
});

export const getTranslatedButtonsDataAction: (surveyId: string, langCode: string) => GetTranslatedButtonsDataAction = (
	surveyId,
	langCode
) => ({
	type: GET_TRANSLATED_BUTTONS_DATA,
	payload: { surveyId, langCode },
});

export const postTranslateButtonsData: (surveyId: string) => PostTranslateButtonsData = (surveyId) => ({
	type: POST_TRANSLATE_BUTTONS_DATA,
	payload: { surveyId },
});

export const setTranslatedButtonDataAction: (data: any) => SetTranslatedButtonDataAction = (data) => ({
	type: SET_TRANSLATED_BUTTON_DATA,
	payload: { data },
});

export const changeButtonsTranslateInfo: (
	language: string,
	surveyId: string,
	uiText: string,
	textId: string,
	translated_text: string
) => ChangeButtonsTranslateInfo = (language, surveyId, uiText, textId, translated_text) => ({
	type: CHANGE_BUTTONS_TRANSLATE_INFO,
	payload: {
		language,
		surveyId,
		uiText,
		textId,
		translated_text,
	},
});

export const setTranslatedButtonsInfo: (id: string, text: string) => SetTranslatedButtonsInfo = (id, text) => ({
	type: SET_TRANSLATED_BUTTONS_INFO,
	payload: {
		id,
		text,
	},
});

export const updateLangugaeStatus: (id: string, langugaeCode: string, status: string) => UpdateLangugaeStatus = (
	id,
	langugaeCode,
	status
) => ({
	type: UPDATE_LANGUGAE_STATUS,
	payload: {
		id,
		langugaeCode,
		status,
	},
});
